/**
 * Positions an element's center to the given coordinate.
 * @param {Element} elem - the element being positioned
 * @param {[number]} newCenter - the [x,y] coordinates the center is being set to
 * @returns {[number]}
 */
const setLeftTopFromCenter = (elem, newCenter = [0, 0]) => {
  if (!elem) return [0, 0];
  const { clientHeight, clientWidth } = elem;
  const [xCenter, yCenter] = newCenter;
  const leftTop = [xCenter - clientWidth / 2, yCenter - clientHeight / 2];
  elem.style.left = `${leftTop[0]}px`;
  elem.style.top = `${leftTop[1]}px`;
  return leftTop;
};

export default setLeftTopFromCenter;
